import React from 'react';
import Homepage from './components/Homepage';
import './style/homepage.css'
import './style/quizpage.css'

class App extends React.Component {
  render(){
    return(
        <Homepage/>
    )
  }
}

export default App;
